<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-save-file`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M32.38 4a4 4 0 012.832 1.175l7.62 7.64A4 4 0 0144 15.64V42a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h26.38zM12 8H8v32h32V16.83a2 2 0 00-.584-1.412l-6.81-6.83A2 2 0 0031.19 8H31v14a2 2 0 01-2 2H14a2 2 0 01-2-2V8zm15 0H16v12h3.999L20 14a1 1 0 011-1h2a1 1 0 011 1v6h3V8z"/></svg>
</template>
<script>

export default {
  name: 'IconSaveFile',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
